/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_DiscInputs */

const en_us2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disc`)
};

const pt_br2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disco`)
};

const es_419_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disco`)
};

const pt_pt2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disco`)
};

const fr_fr2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disque`)
};

const de_de2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandscheibe`)
};

const it_it2_bodymap_type_disc = /** @type {(inputs: Bodymap_Type_DiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disco`)
};

/**
* | output |
* | --- |
* | "Disc" |
*
* @param {Bodymap_Type_DiscInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_disc = /** @type {((inputs?: Bodymap_Type_DiscInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_DiscInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_disc(inputs)
	if (locale === "es-419") return es_419_bodymap_type_disc(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_disc(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_disc(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_disc(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_disc(inputs)
	return en_us2_bodymap_type_disc(inputs)
});
export { bodymap_type_disc as "bodymap.type.disc" }